<template>
  <div
    class="navbar">
    <div
      class="left">
      <a
        class="collapse"
        @click="$emit('open-sidebar')">
        <SvgIcon 
          icon-class="collapse"/>
      </a>
      <el-breadcrumb 
        separator-icon="el-icon-arrow-right">
        <el-breadcrumb-item 
          v-for="item in matched"
          :key="item.name">
          {{item.meta.title}}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-dropdown 
      trigger="click" 
      @command="data => handleDrop(data)">
      <span>
        <img 
          :src="avatar"/>
        <i class="el-icon-arrow-down" />
      </span>
      <el-dropdown-menu
        slot="dropdown">
        <el-dropdown-item
          command="cart">
          <span
            class="drop-item">
            购物车
          </span>
        </el-dropdown-item>
        <el-dropdown-item
          command="contact">
          <span
            class="drop-item">
            联系我们
          </span>
        </el-dropdown-item>
        <el-dropdown-item
          command="logout">
          <span
            class="drop-item">
            登出
          </span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  computed: {
    ...mapGetters(['user']),
    matched(){
      return this.$route.matched.filter(
        item => item.meta.title ? true: false
      )
    },
    avatar(){
      return this.user.u_photo || '/static/img/avatar.png'
    }
  },
  methods: {
    ...mapMutations(['logout']),
    handleDrop(data){
      switch(data){
        case 'logout':
          this.logout()
          break;
        case 'contact':
          setTimeout(() => {
            window.open(
              'https://wpa1.qq.com/dYb6BIFr?_type=wpa&qidian=true', 
              '_blank'
            )
          })
          break;
        case 'cart':
          this.$router.push({
            name: 'Custom_Cart'
          })
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1rem 0 1.2rem;
  height: 4rem;
  border-bottom: 1px solid #e6e6e6;
  box-sizing: border-box;
  .left{
    display: flex;
    align-items: center;
    column-gap: 1.4rem;
    .collapse{
      font-size: 1.6rem;
      cursor: pointer;
      display: flex;
      align-items: center;
    }
    .el-breadcrumb{
      font-size: 1.2rem;
      >>> .el-breadcrumb__separator{
        margin: 0 .7rem 0 .4rem
      }
    }
  }
  .el-dropdown{
    >>> .el-dropdown-selfdefine{
      display: flex;
      align-items: center;
      column-gap: .35rem;
      cursor: pointer;
      color: $text2;
      user-select: none;
      img{
        width: 3.2rem;
        height: 3.2rem;
        border-radius: 100%;
        object-fit: contain;
        border: 1px solid #efefef;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Navbar.vue